import { render, staticRenderFns } from "./DashboardForm.vue?vue&type=template&id=12755b50"
import script from "./DashboardForm.vue?vue&type=script&lang=js"
export * from "./DashboardForm.vue?vue&type=script&lang=js"
import style0 from "./DashboardForm.vue?vue&type=style&index=0&id=12755b50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports